import ExpressPage from '../containers/Express/Express'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Express = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <ExpressPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Express
